import * as React from "react";
import { toINR } from "../../../service/numberFormat";

export interface IHoldTotalBlockProps {
	total: string;
	usable?: string;
	unusable?: string;
}

const HoldTotalBlock: React.FC<IHoldTotalBlockProps> = props => {
	return (
		<div className="hold_total_block">
			<div className="total_heading">
				<div className="total_label">Total Holding Balance</div>
				<div className="total_value">₹{toINR(props.total, 2)}</div>
			</div>
			{props.usable && (
				<div className="usable_unusable_cont">
					<div className="usable_cont">
						<div className="label ib">Usable</div>
						<div className="value ib">₹{toINR(props.usable, 2)}</div>
					</div>
					<div className="unusable_cont">
						<div className="label ib">Unusable</div>
						<div className="value ib">₹{toINR(props.unusable, 2)}</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default HoldTotalBlock;
